import { Link as GatsbyLink } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'

/*
 ** This dynamic link component can be used globally
 ** in place of <a> tags or Gatsby Link component
 ** and will never throw warning
 */

const Link = ({ children, to, activeClassName, partiallyActive, ...rest }) => {
  // Regex checks for internal links that start with one slash
  const internal = /^\/(?!\/)/.test(to)

  const { target } = rest || {}

  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...rest}
      >
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={to} target={target || '_self'} {...rest}>
      {children}
    </a>
  )
}

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  to: PropTypes.string,
  activeClassName: PropTypes.string,
  partiallyActive: PropTypes.string,
  rest: PropTypes.any,
}

export default Link
